import { RecurrenceDaysOfTheWeek } from '@tableau/self-service-schedules/lib/src/components/Recurrence';

import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { IUserTimeZone } from '~src/sessionManagement/serverApi/types/ISessionInfo';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';

export enum TimeUnit {
  Hours = 'Hours',
  Days = 'Days',
  Weeks = 'Weeks',
  Minutes = 'Minutes'
}

export const MINUTES_PER_HOUR = 60;
export const MINUTES_PER_DAY = 60 * 24;
export const MINUTES_PER_WEEK = 60 * 24 * 7;

export const LAST_MONTH_DAY = 99;

export enum DataFreshnessPolicyOption {
  Default = 'Default',
  AlwaysLive = 'AlwaysLive',
  FreshAfter = 'FreshAfter',
  FreshAt = 'FreshAt'
}

export type DataFreshnessPolicyProps = {
  workbook: IWorkbookInfo;
  validatePolicy: (dialogState: DataFreshnessPolicyState) => void;
}

export enum DataFreshnessRecurrenceType {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week'
}

export interface DataFreshnessRecurrenceEditorState {
  expanded: boolean;
  time: number;
  recurrenceType: DataFreshnessRecurrenceType;
  daysOfMonth: number[];
  daysOfWeek: RecurrenceDaysOfTheWeek[];
  recurrenceSummary: string;
}

export interface UpdateDataFreshnessPolicyFooterProps {
  closeDialog: () => void;
  dismissDialog: () => void;
  updateDataFreshnessPolicy: () => void;
  invalidPolicy: boolean;
}

export type DataFreshnessPolicyState = {
  selectedDataFreshnessPolicy: string;
  refreshAfterValue?: number;
  refreshAfterTimeUnit?: string;
  refreshTimeOfDay?: number;
  refreshAtType?: DataFreshnessRecurrenceType;
  refreshAtDaysOfMonth?: number[];
  refreshAtDaysOfWeek?: RecurrenceDaysOfTheWeek[];
  refreshAtTimezone?: IUserTimeZone;
}

/**
 * The DataFreshnessPolicyDialog contains the DataFreshnessPolicyConfigEditor and a footer buttons
 * The DataFreshnessPolicyConfigEditor contains a set of radio buttons and a DataFreshnessRecurrenceEditor
 */
export type DataFreshnessPolicyDialogProps = {
  workbook: IWorkbookInfo;
  initDialogState: DataFreshnessPolicyState;
  closeDialog: () => void;
  dismissDialog: () => void;
}

export type DataFreshnessPolicyConfigEditorProps = ReactActionDialogBodyProps<DataFreshnessPolicyProps, DataFreshnessPolicyState>;
